export default "__VITE_ASSET__CheqtVSj__"